import { Routes } from '@angular/router';
import { LoginComponent } from './feature-login/src/lib/login/login.component';

export const LOGIN_ROUTES: Routes = [
  {
    path: '',
    component: LoginComponent,
  },
  {
    path: '**',
    redirectTo: '',
  },
];
